// #region setAcceptInviteFlowAsInProgress
const ACCEPT_INVITE_FLOW_IN_PROGRESS = 'ACCEPT_INVITE_FLOW_IN_PROGRESS';
export const setAcceptInviteFlowAsStarted = () => {
  localStorage.setItem(ACCEPT_INVITE_FLOW_IN_PROGRESS, 'true');
};

export const setAcceptInviteFlowAsCompleted = () => {
  localStorage.removeItem(ACCEPT_INVITE_FLOW_IN_PROGRESS);
};

export const isAcceptInviteFlowInProgress = (): boolean => {
  return !!localStorage.getItem(ACCEPT_INVITE_FLOW_IN_PROGRESS);
};
